import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';

export default function RefundPolicy() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="p-4 md:p-8">
        <div className="mx-auto max-w-2xl">
          <div className="mb-8 flex items-center gap-3">
            <Button variant="ghost" size="icon" onClick={() => navigate(-1)}>
              <ChevronLeft className="h-5 w-5" />
            </Button>
            <h1 className="text-2xl font-bold text-foreground" style={{ fontFamily: "'Playfair Display', serif" }}>
              Refund & Cancellation Policy
            </h1>
          </div>

          <div className="prose prose-sm max-w-none text-muted-foreground space-y-4">
            <p className="text-sm text-muted-foreground">Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

            <h2 className="text-lg font-semibold text-foreground">1. Cancellation</h2>
            <p>You may cancel your Pro subscription at any time through the "Manage Billing & Invoices" option on your Subscription page. Upon cancellation:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Your Pro features will remain active until the end of your current billing period.</li>
              <li>Your subscription will not renew after the current period ends.</li>
              <li>Your account will revert to the Free plan with its associated limits.</li>
              <li>Your garden data will be preserved, but you may need to reduce your plant count to within the free plan limit.</li>
            </ul>

            <h2 className="text-lg font-semibold text-foreground">2. Refunds</h2>
            <p>We want you to be satisfied with My Garden Assistant. Our refund policy is as follows:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong className="text-foreground">Within 14 days of first purchase:</strong> If you are not satisfied with the Pro plan, you may request a full refund within 14 days of your initial subscription purchase.</li>
              <li><strong className="text-foreground">After 14 days:</strong> Refunds are not generally provided after the 14-day period, but we will consider requests on a case-by-case basis.</li>
              <li><strong className="text-foreground">Annual plans:</strong> For annual subscriptions, refund requests within 14 days of purchase will receive a full refund. After 14 days, a pro-rated refund may be offered at our discretion.</li>
            </ul>

            <h2 className="text-lg font-semibold text-foreground">3. How to Request a Refund</h2>
            <p>To request a refund, please contact us through the application with your account email and the reason for your request. We aim to process all refund requests within 5–10 business days.</p>

            <h2 className="text-lg font-semibold text-foreground">4. Payment Provider</h2>
            <p>All payments are processed by Paddle, our merchant of record. Refunds will be issued through Paddle to your original payment method.</p>

            <h2 className="text-lg font-semibold text-foreground">5. Free Plan</h2>
            <p>The Free plan is provided at no cost and does not require any payment. There are no charges or refunds associated with the Free plan.</p>

            <h2 className="text-lg font-semibold text-foreground">6. Changes to This Policy</h2>
            <p>We reserve the right to update this policy. Any changes will be reflected on this page with an updated date.</p>

            <h2 className="text-lg font-semibold text-foreground">7. Contact</h2>
            <p>For refund requests or questions about this policy, please contact us through the application.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
